import { Timeline, TimelineItem, TimelineTimestamp } from '@nesso/ui/blocks/timeline';

import { formatClockTime, formatNumericShortDate } from '@/shared/lib/time-utils';

import { formatBillingHistoryLine } from '../lib/format-billing-history-line';
import type { BillingHistoryEntry } from '../model/billing-history.types';

type Props = {
    entries: BillingHistoryEntry[];
};

export function BillingHistory({ entries }: Props) {
    if (entries.length === 0) {
        return <p>No history yet</p>;
    }

    return (
        <Timeline aria-label="History">
            {entries.map((entry) => (
                <TimelineItem
                    key={entry.id}
                    timestamp={
                        <TimelineTimestamp
                            primary={formatNumericShortDate(entry.occurredAt)}
                            secondary={formatClockTime(entry.occurredAt)}
                        />
                    }
                >
                    {formatBillingHistoryLine(entry)}
                </TimelineItem>
            ))}
        </Timeline>
    );
}
